import * as angular from 'angular';

import { IDispatcherService, IDispatcher, IStateActionsService, Store } from '../';
import { State, StateDto } from '../../models';

export interface IStatesStoreService {
    getOne(guid: string): angular.IPromise<State>;
    getAll(): angular.IPromise<State[]>;
    getAll(force: boolean): angular.IPromise<State[]>;
    addOne(target: StateDto): angular.IPromise<State[]>;
    updateOne(target: StateDto): angular.IPromise<State[]>;
    deleteOne(guid: string): angular.IPromise<State[]>;
}

export interface IStatesActionDispatcherService extends IDispatcherService<IStatesStoreService> { }

export class StatesActionDispatcherService implements IStatesActionDispatcherService {
    static serviceId = 'statesActionDispatcherService';

    static $inject = ['stateActionsService'];

    constructor(private _actionService: IStateActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IStatesStoreService> {
        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(this._actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
                addOne: (target: StateDto) => dispatch(this._actionService.addOne(target)),
                updateOne: (target: StateDto) => dispatch(this._actionService.updateOne(target)),
                deleteOne: (guid: string) => dispatch(this._actionService.deleteOne(guid)),
            }
        };
    }
}